import { render, staticRenderFns } from "./ConsultPreDistribution.vue?vue&type=template&id=edfd989c"
import script from "./ConsultPreDistribution.vue?vue&type=script&lang=js"
export * from "./ConsultPreDistribution.vue?vue&type=script&lang=js"
import style0 from "./ConsultPreDistribution.vue?vue&type=style&index=0&id=edfd989c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports